<ng-container *ngIf="!fromVideo">
    <ngx-skeleton-loader [count]="count" [appearance]="appearance" [theme]="theme"> </ngx-skeleton-loader>
</ng-container>
<ng-container *ngIf="fromVideo">
    <div class="uploading_text"> {{videoStatusText}}...</div>
    <ngx-skeleton-loader [count]="count" [appearance]="appearance" [theme]="theme"> </ngx-skeleton-loader>
</ng-container>
